import React from 'react';
import CollegePicker from './CollegePicker';
import { EMPTY_COLLEGE, ELIGIBILITY_YEARS } from '../utils/signupCollege';

/**
 * The sign-up school step: High school / College choice. `children` is the
 * existing high-school UI, shown unchanged when High school is chosen.
 *
 * `value` is the college draft ({college, name, unitid, eligibility}); nothing
 * is sent until the register request. `onSwitchToCollege` lets the page clear
 * its own high-school fields, so a college sign-up never also ships a stale
 * high school. Going back to high school clears the college side here.
 */
export default function SignupSchoolSection({ value, onChange, onSwitchToCollege, disabled, who = 'you', children }) {
  const subject = who === 'athlete' ? "Athlete's" : 'Your';
  const choose = (college) => {
    if (college === value.college) return;
    if (college) {
      if (onSwitchToCollege) onSwitchToCollege();
      onChange({ ...EMPTY_COLLEGE, college: true });
    } else {
      onChange({ ...EMPTY_COLLEGE });
    }
  };

  return (
    <div className="auth-field signup-school">
      <div role="radiogroup" aria-label={`${subject} school level`} style={{ display: 'flex', gap: 16, marginBottom: 8 }}>
        <label className="signup-school__choice" style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          <input
            type="radio"
            id="register_school_level_high_school"
            name="register_school_level"
            checked={!value.college}
            disabled={disabled}
            onChange={() => choose(false)}
          />
          High school
        </label>
        <label className="signup-school__choice" style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          <input
            type="radio"
            id="register_school_level_college"
            name="register_school_level"
            checked={value.college}
            disabled={disabled}
            onChange={() => choose(true)}
          />
          College
        </label>
      </div>

      {!value.college ? children : (
        <>
          <label htmlFor="register_college_field">{subject} college</label>
          <CollegePicker
            inputId="register_college_field"
            value={value.name}
            onInputChange={(text) => onChange({ ...value, name: text, unitid: null })}
            onSelect={(c) => onChange({ ...value, name: c.n, unitid: c.u ?? null })}
            onCommitText={() => {}}
            disabled={disabled}
            className="auth-input"
          />
          <fieldset style={{ border: 0, padding: 0, margin: '12px 0 0' }}>
            <legend style={{ fontSize: 14, fontWeight: 600 }}>Years of eligibility remaining</legend>
            <div style={{ display: 'flex', gap: 14 }}>
              {ELIGIBILITY_YEARS.map((n) => (
                <label key={n} className="signup-school__choice" style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                  <input
                    type="radio"
                    id={`register_eligibility_${n}`}
                    name="register_eligibility"
                    checked={value.eligibility === String(n)}
                    disabled={disabled}
                    onChange={() => onChange({ ...value, eligibility: String(n) })}
                  />
                  {n}
                </label>
              ))}
            </div>
          </fieldset>
        </>
      )}
    </div>
  );
}
